import { useGetPermissions } from 'layouts/customHook';
import React from 'react';
import RefundCompletionMaster from '.';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
const RefundCompletionControlWrapper=()=>{
    const userPermissions = useGetPermissions("completionRefundControl");
    return (
        userPermissions
            ? <RefundCompletionMaster userPermissions={userPermissions} />
            : <PermisionDenied />
    );
}

export default RefundCompletionControlWrapper;